import React from 'react';

function App() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h1>サンプル TOPページ</h1>
      <p>これはReactで作成したサンプルのTOPページです。</p>
    </div>
  );
}

export default App;
